// extracted by mini-css-extract-plugin
export default {"header":"header_header__0CKnp","title":"header_title__aXqw3","logo":"header_logo__-pUAz","icons":"header_icons__jz8cK"};